import { Button } from "antd";
import { useTranslation } from "react-i18next";
import ProductCont from "../../components/ProductCont";
import AnalysisWidget from "../../../../../../Analysis/widget";

export default function Gold({
  id,
  name,
  clients,
  workers,
  investments,
  logo,
  picture,
}) {
  const { t } = useTranslation();

  return (
    <AnalysisWidget
      title={name}
      header={(
        <div className="flex flex-1 justify-content-end">
          <a href={`/app/tif/analysis/programs/${id}`} target="_blank" rel="noreferrer" >
            <Button type="primary">
              {t('Details')}
            </Button>
          </a>
        </div>
      )}
      className="with-border-header mb-lg no-p-body overflow-hidden">
      <ProductCont
        clients={clients}
        workers={workers ? Number(workers).toLocaleString('en-us') : '--'}
        investments={investments || '--'}
        imgSrc={picture}
        name={name}
        logo={logo}
      />
    </AnalysisWidget>
  )
}

